import { IPhotobook, IPhotobookSpread, IProductDetails } from '../store/slices/photobook';

export interface IPhotobookCartValidationData {
  _id: string;
  slug: string;
  spreads: IPhotobookSpread[];
  productDetails: IProductDetails;
}

const getStorageKey = () => `photobook_cart_validation_${window.SITE_ID}`;

export const savePhotobooksToLocalStorage = (photobooks: IPhotobookCartValidationData[]) => {
  try {
    const key = getStorageKey();
    const minimalData = photobooks.map(({ _id, slug, spreads, productDetails }) => ({
      _id,
      slug,
      spreads,
      productDetails
    }));
    localStorage.setItem(key, JSON.stringify(minimalData));
  } catch (error) {
    console.error('Failed to save photobooks to localStorage:', error);
  }
};

export const getPhotobooksFromLocalStorage = (): IPhotobookCartValidationData[] => {
  try {
    const key = getStorageKey();
    const data = localStorage.getItem(key);

    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Failed to read photobooks from localStorage:', error);

    return [];
  }
};

export const clearPhotobooksFromLocalStorage = () => {
  try {
    const key = getStorageKey();

    localStorage.removeItem(key);
  } catch (error) {
    console.error('Failed to clear photobooks from localStorage:', error);
  }
};

/**
 * Syncs photobooks that are in the cart to localStorage
 * @param photobooks - All available photobooks from the store
 * @param cartPhotobookIds - IDs of photobooks that are in the cart
 */
export const syncCartPhotobooksToLocalStorage = (
  photobooks: IPhotobook[],
  cartPhotobookIds: string[]
) => {
  const cartPhotobooks = photobooks
    .filter((pb) => cartPhotobookIds.includes(pb._id))
    .map(({ _id, slug, spreads, productDetails }) => ({
      _id,
      slug,
      spreads,
      productDetails
    }));

  savePhotobooksToLocalStorage(cartPhotobooks);
};
